import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('workflow_estrutural', 'execucao/orcamento');

const workflowOrcamento = {
  aprovador: { method: 'GET', url: `${basePath}/{idOrcamento}/passos/aprovador` },
  aprovar: { method: 'PUT', url: `${basePath}/{idOrcamento}/passos/aprovar` },
  cancelar: { method: 'PUT', url: `${basePath}/{idOrcamento}/cancelar` },
  gravar: { method: 'POST', url: `${basePath}/{idOrcamento}` },
  pendentes: { method: 'GET', url: `${basePath}/busca-fluxo-pendente` },
  reprovar: { method: 'PUT', url: `${basePath}/{idOrcamento}/passos/reprovar` },
  status: { method: 'GET', url: `${basePath}/{idOrcamento}/status` },
  statusPasso: { method: 'GET', url: `${basePath}/{idOrcamento}/passos/status` },
  minhasAprovacoes: { method: 'GET', url: `${basePath}/fluxos/aprovador` },
  solicitante: { method: 'GET', url: `${basePath}/solicitante` },
};

export default resource => resource(`${basePath}`, {}, workflowOrcamento);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/workflow-orcamento.js